interface PlayerStatRowProps {
  name: string;
  matches: number;
  wins: number;
  losses: number;
  winRate: number;
}

/**
 * One person's line in a partner/opponent breakdown: name, jogos, V, D, %.
 * Shared by the per-ranking dashboard tab and the cross-ranking /stats page so
 * the two read identically.
 */
export function PlayerStatRow({ name, matches, wins, losses, winRate }: PlayerStatRowProps) {
  return (
    <div className="flex items-center justify-between">
      <span className="text-white/80 text-sm truncate w-[110px]">{name}</span>
      <div className="flex items-center gap-3 text-right">
        <span className="text-white/60 text-sm w-8">{matches}</span>
        <span className="text-success-green text-sm font-medium w-6">{wins}</span>
        <span className="text-coral text-sm font-medium w-6">{losses}</span>
        <span
          className={`text-sm font-medium w-10 ${
            winRate >= 50 ? 'text-success-green' : 'text-warning-orange'
          }`}
        >
          {winRate}%
        </span>
      </div>
    </div>
  );
}

/** Column headings matching PlayerStatRow's layout. */
export function PlayerStatHeader({ label }: { label: string }) {
  return (
    <div className="flex items-center justify-between text-xs text-white/40 px-1">
      <span className="w-[110px]">{label}</span>
      <div className="flex items-center gap-3 text-right">
        <span className="w-8">Jogos</span>
        <span className="w-6">V</span>
        <span className="w-6">D</span>
        <span className="w-10">%</span>
      </div>
    </div>
  );
}
